module.exports = __webpack_public_path__ + "img/logout.ab95de80.svg";